var React = require('react');

function StockLevels (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M1.253 5.38h6.705a4.091 4.091 0 0 0 7.81 0h17.98c.7 0 1.252-.553 1.252-1.253 0-.7-.553-1.253-1.253-1.253H15.805C15.253 1.253 13.705 0 11.863 0s-3.39 1.253-3.905 2.91H1.253C.553 2.91 0 3.464 0 4.164S.553 5.38 1.253 5.38Zm32.495 9.725h-6.706a4.091 4.091 0 0 0-7.81 0H1.252c-.7 0-1.252.553-1.252 1.253 0 .7.553 1.253 1.253 1.253h17.979a4.091 4.091 0 0 0 7.81 0h6.706c.7 0 1.252-.553 1.252-1.253 0-.7-.553-1.253-1.252-1.253Zm0 12.232H15.805a4.091 4.091 0 0 0-7.81 0H1.253c-.7 0-1.253.553-1.253 1.253 0 .7.553 1.252 1.253 1.252h6.705a4.091 4.091 0 0 0 7.81 0h17.98c.7 0 1.252-.552 1.252-1.252s-.553-1.253-1.252-1.253Z"}));
}

StockLevels.defaultProps = {"fill":"none","viewBox":"0 0 35 33"};

module.exports = StockLevels;

StockLevels.default = StockLevels;
